import Fetcher from "./Shared/FetchService";
const teamUrl = "/aviso/team/";
export default class EngagementService {
    static getTeams(params) {
        return Fetcher.getSingleResponse(teamUrl + "list", Object.assign({ format: "json" }, params));
    }
    static getTeam(params) {
        return Fetcher.getSingleResponse(teamUrl + "details", params);
    }
}
